import React from "react";

// Nine-category scorecard. scores: {key: 0-10|null}, categories: [{key,label}]
export function Scorecard({ scores = {}, categories = [] }) {
  return (
    <div data-testid="scorecard" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-0 border-t border-l border-stone-900">
      {categories.map((c) => {
        const v = scores?.[c.key];
        const has = v != null && v !== "";
        return (
          <div key={c.key} data-testid={`scorecard-cell-${c.key}`}
            className="border-r border-b border-stone-900 p-5 flex flex-col justify-between min-h-[130px] bg-white">
            <div className="font-mono-pm text-[11px] tracking-wide uppercase text-stone-600 leading-tight">{c.label}</div>
            <div className="mt-4">
              <div className="flex items-baseline gap-1">
                <span className="font-mono-pm text-3xl font-black text-stone-900">{has ? v : "—"}</span>
                <span className="font-mono-pm text-xs text-stone-500">/10</span>
              </div>
              <div className="mt-2 h-1.5 w-full bg-stone-200">
                <div className="h-full bg-stone-900" style={{ width: has ? `${(v / 10) * 100}%` : "0%" }} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
